<template>
    <div class="category">
        <div @click="changeCurrent(item.id)" v-for="(item,key) in list" :key="key" :class="{'isActive':current.categoryId == item.id}">
            {{item.name}}
        </div>
    </div>
</template>
<script>
export default {
    props:['list','current'],
    data(){
        return {
        }
    },
    methods:{
        changeCurrent(val){
            this.$emit('changeCurrent',val)
        }
    }
}
</script>>
<style >
    .category{
        width: 100%;
        overflow-x: scroll;
        white-space: nowrap;
        height: 2.5rem;
    }
    .category div{
        width: 2rem;
        display: inline-block;
        margin:0rem 1rem;
        height: 2.5rem;
        line-height: 2.5rem;
        color: #A19E9E;
    }
    .category .isActive{
        color: #01999D;
    }
</style>